import { render, staticRenderFns } from "./zazhi_dialog.vue?vue&type=template&id=525da9f8"
import script from "./zazhi_dialog.vue?vue&type=script&lang=js"
export * from "./zazhi_dialog.vue?vue&type=script&lang=js"
import style0 from "./zazhi_dialog.vue?vue&type=style&index=0&id=525da9f8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports